import React from 'react';
import {
  Section,
  SettingsSectionBox,
  SettingsSectionLabel,
  SettingToggle,
} from '@views/Settings/components';
import styles from './Merging.module.scss';
import useEnabledNotifications from '../../Notifications/use-enabled-notifications';

export default function MergingSettings() {
  const { enabledNotifications, toggleNotification } = useEnabledNotifications();

  return (
    <Section>
      <SettingsSectionLabel>Merging</SettingsSectionLabel>
      <SettingsSectionBox className={styles.container}>
        <SettingToggle
          title="Resolve Duplicates"
          checked={enabledNotifications['resolve_duplicates']}
          name="resolve_duplicates"
          onChange={() => toggleNotification('resolve_duplicates')}
        />
        <p>
          This enables intelligent contact deduplication and merges your duplicate contacts across
          all your Clay integrations. It is turned on by default.
        </p>
      </SettingsSectionBox>
    </Section>
  );
}
